import { render } from "./courseHistory.vue?vue&type=template&id=e46d8864"
import script from "./courseHistory.vue?vue&type=script&lang=js"
export * from "./courseHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__